export default "__VITE_ASSET__B2es4yhU__"